import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapDEPBResponse } from "@/redux/mappers/Export/CreateNewJob/DEPBMapper";
export const productDEPBApi = createApi({
  reducerPath: "productDEPBApi",
  baseQuery,
  tagTypes: ["productDEPB"],
  endpoints: (builder) => ({
    getProductDEPB: builder.query({
      query: ({ id }) => `export/product/depb/${id}`,
      transformResponse: (response) => {
        return response?.data?.map(mapDEPBResponse)?.[0] ?? [];
      },
      providesTags: ["productDEPB"],
    }),

    createProductDEPB: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/product/depb/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductDEPB: data },
      }),
      invalidatesTags: ["productDEPB"],
    }),

    updateProductDEPB: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/general/68c54f831f17f10baf8f692b`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { productGeneral: data },
      }),
      invalidatesTags: ["productDEPB"],
    }),

    createProductDEPBTable: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/product/depbTable/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { ExportProductDEPBItem: data },
      }),
      invalidatesTags: ["productDEPB"],
    }),

    updateProductDEPBTable: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `export/product/depbTable/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { ExportProductDEPBItem: data },
      }),
      invalidatesTags: ["productDEPB"],
    }),

    deleteProductDEPBTable: builder.mutation({
      query: ({ id }) => ({
        url: `export/product/depbTable/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["DucRef"],
    }),

    getProductDEPBTable: builder.query({
      query: ({ id }) => `export/product/depbTable/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];

        return normalized.map((item) => ({
          ...item,
          id: item.exportProductDEPBItemId,
        }));
      },
      providesTags: ["productDEPB"],
    }),
  }),
});

export const {
  useLazyGetProductDEPBQuery,
  useCreateProductDEPBMutation,
  useUpdateProductDEPBMutation,
  useCreateProductDEPBTableMutation,
  useLazyGetProductDEPBTableQuery,
  useUpdateProductDEPBTableMutation,
  useDeleteProductDEPBTableMutation,
} = productDEPBApi;
